/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * OutingPunchRecordIcon - Auto-generated from icon.js
 */
export const OutingPunchRecordIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M2.69063 4.72287L15.3577 17.0894M2.69063 4.72287C3.16193 4.18482 3.86585 3.84324 4.65231 3.84324H8.93448M2.69063 4.72287C2.31158 5.15562 2.08301 5.71546 2.08301 6.3269V15.4337C2.08301 16.8053 3.23332 17.9173 4.65231 17.9173H14.0731C15.4921 17.9173 16.6424 16.8053 16.6424 15.4337V11.7082M8.93448 11.7082L3.36766 17.0894M15.0045 4.8988V4.84588M17.9163 4.83761C17.9163 6.67336 15.0045 9.12102 15.0045 9.12102C15.0045 9.12102 12.0926 6.67336 12.0926 4.83761C12.0926 3.31682 13.3963 2.08398 15.0045 2.08398C16.6126 2.08398 17.9163 3.31682 17.9163 4.83761Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);

export default OutingPunchRecordIcon;
